import React from 'react';
import styled from 'styled-components';
import { ImpactClaimTitle } from 'components/Shared/ImpactClaims';
import Header from './Header';
const HEADER_CONTAINER_HEIGHT = 130;
const ClaimContainer = styled.div `
  padding: 0 32px 0 32px;
  overflow: auto;
  height: calc(100% - ${HEADER_CONTAINER_HEIGHT}px);
`;
const ImpactClaimSlideContent = ({ detailNode, onClaimClick, }) => {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { activity: detailNode, isActive: true }),
        React.createElement(ClaimContainer, null, (_a = detailNode === null || detailNode === void 0 ? void 0 : detailNode.impactClaims) === null || _a === void 0 ? void 0 : _a.edges.map((impactClaim) => (React.createElement(ImpactClaimTitle, { key: impactClaim.node.id, onClaimClick: onClaimClick, impactClaim: impactClaim.node, active: false }))))));
};
export default ImpactClaimSlideContent;
